import { Layout, Orientation } from '../../components/handler-components/ResizeHandler';
import { SIDE_BAR_TABS } from '../../data-types/betting/bettingEnums';
import { FadeOutOverlayData } from '../../data-types/initialisation/initialisationInterfaces';
import { SubNavItem } from '../../data-types/main-menu/mainMenuInterfaces';
import { SEARCH_TYPE } from '../../data-types/search/searchEnums';
import { EVENT_DETAIL_DISPLAY_TYPE } from '../../data-types/sports/sportsEnums';
import { store } from '../store';
import {
  SET_DESKTOP_PROFILE_PATH,
  SET_DESKTOP_RENDER_HELP_OPEN,
  SET_EVENT_DETAIL_VIEW_TYPE,
  SET_FADE_OUT_OVERLAY_DATA,
  SET_HEIGHT,
  SET_LAYOUT,
  SET_ORIENTATION,
  SET_PREVENT_REDIRECT_ON_ERROR,
  SET_SEARCH_TEXT,
  SET_SEARCH_TYPE,
  SET_SELECTED_BET_SIDE_BAR_TAB,
  SET_SELECTED_SUB_NAV_ITEM,
  SET_SPORTS_MENU,
  SET_VERIFICATION_OVERLAY,
  SET_WIDTH,
} from '../types/navigationTypes';

export const setSearchText = (searchText: string) => {
  store.dispatch({
    type: SET_SEARCH_TEXT,
    meta: searchText,
  });
};

export const setSearchType = (searchType: SEARCH_TYPE | undefined) => {
  store.dispatch({
    type: SET_SEARCH_TYPE,
    meta: searchType,
  });
};

export const setVerificationOverlay = (open: boolean) => {
  store.dispatch({
    type: SET_VERIFICATION_OVERLAY,
    meta: open,
  });
};

export const setDesktopProfilePath = (meta: string | undefined) => {
  store.dispatch({
    meta,
    type: SET_DESKTOP_PROFILE_PATH,
  });
};

export const setRenderDesktopHelpOpen = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_DESKTOP_RENDER_HELP_OPEN,
  });
};

export const setPreventRedirectOnError = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_PREVENT_REDIRECT_ON_ERROR,
  });
};

export const setFadeOutOverlayData = (meta: FadeOutOverlayData) => {
  store.dispatch({
    meta,
    type: SET_FADE_OUT_OVERLAY_DATA,
  });
};

export const setEventDetailDisplayType = (meta: EVENT_DETAIL_DISPLAY_TYPE) => {
  store.dispatch({
    meta,
    type: SET_EVENT_DETAIL_VIEW_TYPE,
  });
};

export const updateSportsMenu = (sportsMenu: object) => {
  store.dispatch({
    type: SET_SPORTS_MENU,
    meta: {
      ...store.getState().navigation.sportsMenu,
      ...sportsMenu,
    },
  });
};

export const setSelectedBetSideBarTab = (meta: SIDE_BAR_TABS | undefined) => {
  store.dispatch({
    meta,
    type: SET_SELECTED_BET_SIDE_BAR_TAB,
  });
};

export const setLayout = (meta: Layout) => {
  store.dispatch({
    meta,
    type: SET_LAYOUT,
  });
};

export const setWidth = (meta: number) => {
  store.dispatch({
    meta,
    type: SET_WIDTH,
  });
};

export const setHeight = (meta: number) => {
  store.dispatch({
    meta,
    type: SET_HEIGHT,
  });
};

export const setOrientation = (meta: Orientation) => {
  store.dispatch({
    meta,
    type: SET_ORIENTATION,
  });
};

export const setSelectedSubNavItem = (meta: SubNavItem | undefined) => {
  store.dispatch({
    meta,
    type: SET_SELECTED_SUB_NAV_ITEM,
  });
};
